export const novaConfig = {
    theme: "nova-theme", // nova-theme, basic-theme
    router: "nova", // nova, basic
    components: {
        amount: "slider", // 'basic', slider
        showCardIcons: false, // show or hide card icons on credit-card
        error: "top", // top, bottom
        visualCard: false, //true, false
        cardNumber: "transform", // basic, transform
        sliderMethods: "separate", // type of gateways list: separate, slider, beside
        profile: "checkbox" // profile in checkbox or in modal ("checkbox", "modal")
    }
};